import BaseRepository from "../pages/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";
import Kernel from "@oilstone/kernel";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    listing() {
        const testimonials = Kernel.resolve('resourceRegistry').find('testimonials').repository.withTestimonialCategories().then(collection => {
            return collection.map(record => {
                return {
                    type: 'testimonials',
                    resource: record
                }
            });
        });

        return Promise.all([
            testimonials
        ]).then(collections => {
            return [].concat(...collections);
        })
    }
}

export default Repository;
